var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M18.1,2.1L15.9,0l-12,12l12,12l2.1-2.1L8.2,12L18.1,2.1z"}})}
var staticRenderFns = []

export { render, staticRenderFns }